export default {"src":"/_next/static/media/close.a1b93a89.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};